import { TextField } from "@material-ui/core";
import React from "react";
import addIcon from "../../../../../assets/img/add-gray.svg";
import deleteIcon from "../../../../../assets/img/delete-red.svg";
import NumberFormat from "react-number-format";

const Additional = ({
  handleChangeAdditionalTitle,
  handleChangeAdditionalValue,
  removeAdditional,
  addAdditional,
  product,
  adicional,
  index,
}) => {
  const changeNumber = (event) => {
    let value = Number(parseFloat(event.target.value.slice(3).replace(",", ".")).toFixed(2));
    let evento = { ...event, target: { value: value } };
    handleChangeAdditionalValue(evento, index);
  };
  return (
    <div className="d-flex">
      <TextField
        onChange={(event) => handleChangeAdditionalTitle(event, index)}
        value={adicional.title}
        name="title"
        label={"Adicionais"}
        variant={"outlined"}
        className="fz-16 col-4 text-cl-dark-jungle-green ff-univanova mb-4 me-2"
      />
      <NumberFormat
        required
        customInput={TextField}
        variant="outlined"
        name="value"
        label={"Valor da unidade"}
        className="fz-16 col-4 text-cl-dark-jungle-green ff-univanova mb-4 me-2"
        decimalSeparator=","
        prefix={"R$ "}
        decimalScale={2}
        fixedDecimalScale={true}
        placeholder="R$ 0,00"
        value={adicional.value}
        onChange={(event) => {
          changeNumber(event);
        }}
      />
      {adicional !== product.additional[product.additional.length - 1] ? (
        <div className="ms-3 d-flex align-items-center pb-4 c-pointer" onClick={() => removeAdditional(index)}>
          <img alt="delete variation" className="me-2" src={deleteIcon} />
        </div>
      ) : (
        <></>
      )}
      {adicional === product.additional[product.additional.length - 1] ? (
        <>
          <div
            className="ms-2 d-flex align-items-center c-pointer text-cl-light-blue-steel pb-4"
            onClick={() => addAdditional()}
          >
            <img alt="delete variation " className="me-2 text-cl-light-blue-steel" src={addIcon} />
            <span>Adicionar</span>
          </div>
          <div className="ms-3 d-flex align-items-center pb-4 c-pointer" onClick={() => removeAdditional(index)}>
            <img alt="delete variation" className="me-2" src={deleteIcon} />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Additional;
